import React from 'react';
import { StyleSheet, View } from 'react-native';
import { withNavigationFocus } from 'react-navigation';
import { Auth } from 'aws-amplify';

// Components
import { DRNInputField, DRNButton, DRNText } from '@traveloka/district-ui';
import TOSLogo from 'common/res/svg/TosLogo';
import NewPasswordValidity, {
  validatePassword,
} from 'common/components/PasswordValidation/PasswordValidation';
import PasswordInput from 'common/components/PasswordInput/PasswordInput';

// Constants
import R from 'common/res/R';

import {
  withPageStateProvider,
  pageState,
} from 'common/libs/PageState/pageState';

@withNavigationFocus
@withPageStateProvider()
@pageState()
class ResetPasswordScreen extends React.Component {
  state = {
    code: '',
    email: '',
    errorEmail: '',
    newPassword: '',
    confirmNewPassword: '',
    confirmNewPasswordError: '',
    isLoading: false,
    showNewPasswordValidity: false,
  };

  componentDidMount() {
    const { navigation } = this.props;

    const email = navigation.getParam('ea');

    if (email) this.setState({ email: navigation.getParam('ea') });
  }

  @pageState({ error: 'snackbar.error' })
  handleResetPassword = async () => {
    const { email, code, newPassword } = this.state;
    const { navigation } = this.props;

    try {
      this.setState({ isLoading: true });
      await Auth.forgotPasswordSubmit(email, code, newPassword);
      navigation.navigate('Login');
    } catch (error) {
      throw error;
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleEmailChange = event => {
    const email = event.target.value || '';
    this.setState({
      email,
    });

    this.validateEmail(email);
  };

  handleNewPasswordChange = event => {
    const newPassword = event.target.value || '';
    this.setState({ newPassword });

    if (!validatePassword(newPassword).isValid) {
      this.setState({ showNewPasswordValidity: true });
    }
  };

  handleConfirmNewPasswordChange = event => {
    const confirmNewPassword = event.target.value || '';
    const { newPassword } = this.state;

    if (confirmNewPassword !== newPassword) {
      this.setState({ confirmNewPasswordError: 'Password does not match' });
    } else {
      this.setState({ confirmNewPasswordError: '' });
    }

    this.setState({ confirmNewPassword });
  };

  validateEmail = email => {
    if (!email) {
      return this.setState({ errorEmail: 'Email is required' });
    }

    const emailRegex = new RegExp(
      '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'
    );

    if (!emailRegex.test(email)) {
      return this.setState({ errorEmail: 'Email is invalid' });
    }

    return this.setState({ errorEmail: '' });
  };

  render() {
    const {
      code,
      confirmNewPassword,
      confirmNewPasswordError,
      email,
      errorEmail,
      isLoading,
      newPassword,
      showNewPasswordValidity,
    } = this.state;
    const isButtonDisabled =
      errorEmail ||
      isLoading ||
      confirmNewPasswordError ||
      !newPassword ||
      !code ||
      !validatePassword(newPassword).isValid;

    return (
      <View style={styles.page}>
        <View style={styles.container}>
          <View style={styles.logoContainer}>
            <TOSLogo />
          </View>
          <View style={styles.formContainer}>
            <DRNText variant="ui-small" ink="secondary">
              Please enter your new password and re-confirm your new password
              and input the code you receive from your email.
            </DRNText>
            <DRNInputField
              label="E-mail"
              value={email}
              error={errorEmail}
              variant={DRNInputField.VARIANT_STANDARD}
              onChange={this.handleEmailChange}
            />
            <DRNInputField
              label="Code"
              value={code}
              variant={DRNInputField.VARIANT_STANDARD}
              onChange={event => this.setState({ code: event.target.value })}
            />
            <PasswordInput
              label="New Password"
              value={newPassword}
              variant={DRNInputField.VARIANT_STANDARD}
              onChange={this.handleNewPasswordChange}
            />
            <NewPasswordValidity
              password={newPassword}
              show={showNewPasswordValidity}
            />
            <PasswordInput
              label="Confirm New Password"
              value={confirmNewPassword}
              variant={DRNInputField.VARIANT_STANDARD}
              onChange={this.handleConfirmNewPasswordChange}
              error={confirmNewPasswordError}
            />

            <DRNButton
              size="medium"
              onPress={this.handleResetPassword}
              text="Submit"
              variant="main-cta"
              style={{ marginTop: 16 }}
              isLoading={isLoading}
              disabled={isButtonDisabled}
            />
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  page: {
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  container: {
    width: 400,
    backgroundColor: 'white',
  },
  logoContainer: {
    padding: 16,
    backgroundColor: R.color.brand,
    justifyContent: 'center',
  },
  formContainer: {
    padding: 16,
  },
});

export default ResetPasswordScreen;
